import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import MandatoryField from 'modules/_shared/components/MandatoryField';

import { useBeneficiaryTenderOfferSelectorModal } from '../context/BeneficiaryTenderOfferSelectorModalContext';

const BeneficiaryTenderOfferSelectorModalBody: FC = () => {
  const { t } = useTranslate();
  const animatedComponents = makeAnimated();

  const { data, actions } = useBeneficiaryTenderOfferSelectorModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="form-group">
          <label className="form-label" htmlFor="tender-offer-selector">
            {t('SelectOffer')} <MandatoryField />
          </label>
          <div className="form-control-wrap">
            <Select
              className="react-select react-select-lg"
              value={data.selectedTenderOfferOption}
              options={data.tenderOfferOptions}
              components={animatedComponents}
              onChange={actions.handleChangeTenderOfferOption}
            />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

export default BeneficiaryTenderOfferSelectorModalBody;
